import { defineSlotRecipe } from '@chakra-ui/react'
import { menuAnatomy } from '@chakra-ui/react/anatomy'

const common = {
    content: {
        border: '2px solid',
        borderRadius: '4px',
        _light: {
            borderColor: 'rgb(239, 239, 237)',
            boxShadow: '0 4px 10px 1px rgba(84, 79, 64, 0.14)',
        },
        _dark: {
            backgroundColor: 'black',
            borderColor: 'rgba(84, 79, 64, 0.4)',
            boxShadow: '0px 4px 10px 1px rgb(0, 0, 0)',
        },
    },
    item: {
        backgroundColor: 'transparent',
        borderRadius: 0,
        position: 'relative',
        _hover: {
            borderColor: 'transparent',
            cursor: 'pointer',
        },
        _focus: {
            boxShadow: 'none',
            outline: 0,
        },
        _focusVisible: {
            boxShadow: 'none',
            outline: 0,
        },
        _light: {
            color: 'dark.700',
            _hover: {
                backgroundColor: 'gray.100',
            },
        },
        _dark: {
            _hover: {
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
            },
        },
        '.chakra-badge': {
            position: 'absolute',
            top: '-10px',
            right: '0px',
        },
    },
}

export const menuSlotRecipe = defineSlotRecipe({
    slots: menuAnatomy.keys(),
    variants: {
        variant: {
            export: {
                content: {
                    paddingInline: 0,
                    minWidth: '225px',
                    _dark: {
                        backgroundColor: 'dark.600',
                    },
                },
                itemGroup: {
                    paddingInline: 3,
                },
                item: {
                    borderRadius: 0,
                    paddingInline: 3,
                    cursor: 'pointer',
                    _disabled: {
                        cursor: 'disabled',
                    },
                    _hover: {
                        backgroundColor: 'gray.100',
                    },
                    _dark: {
                        _hover: {
                            backgroundColor: 'dark.700',
                        },
                    },
                },
            },

            profile: {
                content: {
                    ...common.content,
                    padding: '0',
                    minWidth: '225px',
                },

                itemGroupLabel: {
                    fontSize: '12px',
                    fontWeight: 'normal',
                    marginTop: '12px',
                    _light: {
                        color: 'rgba(84, 79, 64, 0.7)',
                    },
                    _dark: {
                        color: 'rgba(255, 255, 255, 0.7)',
                    },
                },
                itemText: {
                    justifyContent: 'start',
                },
                item: {
                    ...common.item,
                    fontSize: '14px',
                    padding: '8px 12px',
                    '&.logout': {
                        color: 'status.error',
                    },
                },
            },
            feedback: {
                content: {
                    ...common.content,
                    padding: '15px 0',
                    minWidth: '200px',
                },
                item: {
                    ...common.item,
                    padding: '10px 20px',
                    lineHeight: '1',
                },
                itemGroupLabel: {
                    fontWeight: 'bold',
                    margin: '0',
                    padding: '5px 0 10px 20px',
                },
            },
            settings: {
                content: {
                    ...common.content,
                    padding: '0',
                    minWidth: '230px',
                },
                item: {
                    ...common.item,
                    justifyContent: 'start',
                    fontSize: '14px',
                },
                divider: {
                    borderColor: 'gray.300',
                    margin: '12px 12px',
                },
                itemGroupLabel: {
                    maxWidth: '200px',
                    fontWeight: 'regular',
                    fontSize: '12px',
                    lineHeight: '16px',
                    marginLeft: '12px',
                    _light: {
                        color: 'rgba(84,79,64, 0.7)',
                    },
                    _dark: {
                        color: 'rgba(255,255,255, 0.7)',
                    },
                },
            },
            helpCenter: {
                content: {
                    ...common.content,
                    padding: '0',
                    minWidth: '200px',
                },
                item: {
                    ...common.item,
                    fontSize: '14px',
                    padding: '8px 12px',
                },
                itemGroupLabel: {
                    fontSize: '12px',
                    fontWeight: 'normal',
                    marginTop: '12px',
                    _light: {
                        color: 'rgba(84, 79, 64, 0.7)',
                    },
                    _dark: {
                        color: 'rgba(255, 255, 255, 0.7)',
                    },
                },
            },
        },
    },
})
